import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import axios from 'axios';
import { useAtom, useSetAtom } from 'jotai';
import { contactDemandeState, diagnosticParcellesState, envContraintesState } from '@/store';

export default function DemandeDialog() {
  const ref = useRef();

  const [contactDemande, setContactDemande] = useAtom(contactDemandeState);

  const setEnvContraintes = useSetAtom(envContraintesState);
  const setDiagnosticParcelles = useSetAtom(diagnosticParcellesState);

  const [open, setOpen] = useState(false);

  const clearProject = () => {
    setContactDemande(null);
    setEnvContraintes(null);
    setDiagnosticParcelles(null);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const postContactDemande = () => {
    axios
      .post(`${import.meta.env.VITE_NEOSYLVA_API_URL}/contact`, contactDemande, {
        headers: {
          'neosylva-api-key': import.meta.env.VITE_NEOSYLVA_API_KEY,
        },
      })
      .then(({ data }) => {
        if (data?.success === true) {
          setOpen(true);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        clearProject();
      });
  };

  useEffect(() => {
    if (contactDemande) {
      postContactDemande();
    }
  }, [contactDemande]);

  return (
    <div ref={ref}>
      <Dialog
        container={ref.current}
        maxWidth="xs"
        fullWidth={true}
        open={open}
        onClose={null}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent dividers={true}>
          <DialogContentText align="center" sx={{ fontWeight: 'bold' }}>
            MERCI
            <br />
            <br />
            Votre demande nous a bien été transmise.
            <br />
            Notre équipe vous recontactera prochainement.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ mr: 2 }}>
          <Button variant="contained" onClick={handleDialogClose}>
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
